import { ajax } from "@utils";

export const newsService = {
  /**
   * 新增社區公告資訊
   * @key CreateConstructionNewsByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 社區公告資訊
   *
   * @returns
   */
  create: (constructionUuid, info) => {
    return ajax
      .post(`${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/news`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 取得社區公告列表
   * @key SearchConstructionNewsByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/news`, {
        params: {
          ...condition
        }
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 取得社區公告資訊
   * @key GetConstructionNewsByProperty
   * @param {number} id - 公告 id
   * @returns
   */
  get: id => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/constructions-news/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 更新社區公告資訊
   * @key UpdateConstructionNewsByProperty
   * @param {number} id - 社區公告 id
   * @param {object} info - 社區公告資訊
   * @returns
   */
  update: (id, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/constructions-news/${id}`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 刪除社區公告
   * @key DeleteConstructionNewsByProperty
   * @param {number} id - 社區公告 id
   * @returns
   */
  delete: id => {
    return ajax
      .delete(`${process.env.REACT_APP_API_URL}/property/constructions-news/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 發佈社區公告
   * @key PublishConstructionNewsByProperty
   * @param {number} id - 社區公告 id
   * @param {object} info - 發佈資訊
   * @returns
   */
  publish: (id, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/constructions-news/${id}/publish`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 置頂社區公告
   * @key PinConstructionNewsByProperty
   * @param {number} id - 社區公告 id
   * @param {object} info - 置頂資訊
   * @returns
   */
  pin: (id, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/constructions-news/${id}/pin`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 取得社區公告分類清單
   * @key ListConstructionNewsTypeByProperty
   * @param {string} construcitonUuid - 建案 uuid
   * @returns
   */
  getTypeOptions: constructionUuid => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/news-types/list`
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 取得社區公告讀取戶別數
   * @key ListOperateOptionByProperty
   * @param {number} id - 社區公告 id
   * @returns
   */
  getReadHouseholds: id => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/constructions-news/${id}/read-households`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  }
};
